import React from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Rajesh Kumar",
    location: "New Bihar",
    role: "Homeowner",
    initials: "RK",
    rating: 5,
    feedback:
      "We have been using Oster inverter battery for two years now. During heavy load shedding in Bihar summers, this battery gives full backup without any problem. Very reliable — highly recommend to every household.",
  },
  {
    name: "Suresh Yadav",
    location: "Bihar",
    role: "E-Rickshaw Driver",
    initials: "SY",
    rating: 5,
    feedback:
      "Pehle main dusri battery use karta tha, but after switching to Oster my rickshaw runs 12 hours daily without any breakdown. Warranty is also very good. Oster battery has given me tension-free earning.",
  },
  {
    name: "Priya Sharma",
    location: "Bihar",
    role: "Shop Owner",
    initials: "PS",
    rating: 5,
    feedback:
      "We installed Oster solar battery on our shop rooftop. Even when bijli jaati hai for 6–7 hours in peak summer, our shop runs smoothly. Very happy with the performance — worth every rupee invested.",
  },
  {
    name: "Amarjit Singh",
    location: "Bihar",
    role: "Farmer",
    initials: "AS",
    rating: 5,
    feedback:
      "My tractor never fails to start even on cold winter mornings. Oster battery is truly made for Indian conditions. Already recommended to five farmers in my village. Best quality battery available in the market.",
  },
];

function StarRating({ count }) {
  return (
    <div className="star-rating" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }, (_, i) => (
        <svg
          key={i}
          className={`star${i < count ? " filled" : ""}`}
          viewBox="0 0 24 24"
          fill={i < count ? "currentColor" : "none"}
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

function Testimonials() {
  return (
    <section className="testimonials">
      <div className="testimonials-container">

        <div className="testimonials-header">
          <span className="testimonials-eyebrow">Customer Stories</span>
          <h2 className="testimonials-title">
            Trusted Across <span className="title-accent">India</span>
          </h2>
          <p className="testimonials-subtitle">
            From homes in Delhi to fields in Punjab — Oster powers every corner of India.
          </p>
        </div>

        <div className="testimonial-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <div className="card-quote-bg">"</div>
              <StarRating count={t.rating} />
              <p className="testimonial-feedback">"{t.feedback}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">{t.initials}</div>
                <div className="author-info">
                  <span className="author-name">{t.name}</span>
                  <span className="author-meta">{t.role} &middot; {t.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Testimonials;
